import { render, staticRenderFns } from "./LinkBubbleView.vue?vue&type=template&id=0d5b826e&scoped=true"
import script from "./LinkBubbleView.vue?vue&type=script&lang=js"
export * from "./LinkBubbleView.vue?vue&type=script&lang=js"
import style0 from "./LinkBubbleView.vue?vue&type=style&index=0&id=0d5b826e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5b826e",
  null
  
)

export default component.exports